<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row  class="table-header">
          <el-col>
            <el-button type="primary" size="medium" icon="iconfont icon-tianjiacaidan2" v-if="userPermissions.indexOf('contract_create') != -1 && buttonType=='text'" @click="addButton(0)">&nbsp;上传合同</el-button>
          </el-col>
        </el-row>
        <ApeTable ref="apeTable" :data="contractList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            v-if="buttonType=='text'"
            label="操作"
            align="center">
            <template slot-scope="scope">
              <span>
                <el-button size="mini" type="text" @click="mxPreview(scope.row.file_url)">
                  <i class="iconfont iconwenjian iconbtn iconBtns"></i>
                </el-button>
                <el-button size="mini" type="text" @click="mxGoUrl(scope.row.file_url)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
         <el-form ref="contractForm" :model="formData" :rules="rules" label-width="100px">
            <el-col :span="24" class="content-left">
               <el-form-item label="上传文件" prop="file_url">
                <upload-file
                  @remove_file="handleRemoveFile"
                  @return_url="handUploadFile"
                  :title="title"
                  :multiple="'false'"
                  :multiSelection="false"
                  :dir="'contract'"
                  :selectfiles="'importExcel'"
                  :postfiles="'submitImportExcel'"
                  :ossfile="'ossExcelFile'"
                  ref="uploadImg"
                  :max_width="1000"
                  :max_height="1000"
                />
               </el-form-item>
            </el-col>
          </el-form>
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeUploader,
    ModalDialog,
    UploadFile
  },
  data() {
    return {
      loadingStaus: false,
      dialogData:{
        visible: false,
        title: '',
        width: '45%',
        loading: true,
        modal: false
      },
      columns: [
        {
          title: '上传时间',
          value: 'created_at',
          width: 200,
          header_align: 'center',
          align: 'center',
        },
        {
          title: '更新时间',
          value: 'updated_at',
          width: 200,
          header_align: 'center',
          align: 'center',
        },
        {
          title: '上传人',
          width: 200,
          header_align: 'center',
          align: 'center',
          value: 'fullname'
        },
        {
          title: '状态',
          width: 200,
          header_align: 'center',
          align: 'center',
          value: 'alias_status'
        },
      ],
      // 表格列表数据
      contractList:[
        // {
        //   uploadTime: '2020/05/25  10:12',
        //   uploadPeoson: '赖头'
        // },
      ],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {},
      // rules: {
      //   file_url: [
      //     {required: true, message: '请选择文件', trigger: 'blur' },
      //   ],
      // },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      title: '合同',
      activeTab: '0',
      hearTitle: '基本设置',
      loadingText: '正在加载中……',
      formDisabled: false,
      contractId:0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      // 分类列表
      categoryList:[],
      openapiList:[],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 公司基本信息表单结构
      formData:{
        file_url: '',
        status: 0
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    // 响应添加按钮
    async addButton(pid,name) {
      // 添加子权限，拼接的前缀
      if (name) {
        this.namePrefix = name+'_'
      }
      this.dialogData.visible = true
      this.dialogData.title = pid?'添加子合同':'添加合同'
      // this.initForm()
    },
    // 初始化form，将添加，编辑共同数据抽取出来
    // async initForm() {
    //   this.dialogData.loading = false
    // },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initData()
    },
    // 初始化数据
    initData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.isInherit= true
        this.namePrefix= ''
        this.formData = {
          display_name:''
        }
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['contractForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    //导入跳转
    importExcel() {
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id)
    },
     // 初始化列表
    async init() {
      this.loadingStaus=true
      let {list}= await this.$api.getContractList()
      this.contractList = []
      this.$nextTick(() => {
        this.contractList=list
      })
      this.loadingStaus=false
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },

     // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename}) {
      console.log("->上传成功....", url, filename);
      this.formData.file_url = url
      this.dialogData.loading = false
    },
    // 返回列表
    returnList() {
      this.$router.push('/bill')
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v)
      if (v) {
        this.formData.parent_id = v
      }
    },
    openapiChange(v) {
      console.log("openapiChange", v)
      if (v) {
        this.formData.openapi_id = v
      }
    },
    // 级联菜单组件change事件
    cascaderLabelChange(v) {
      if (v.length) {
        this.formData.category_2_id = v[(v.length-1)]
        this.formData.category_2_ids = v
      } else {
         this.formData.category_2_id = ''
         this.formData.category_2_ids = []
      }
    },
    // 级联菜单自定义验证，选择分类
    cascaderVerify(rule, value, callback) {
      if (rule.required && !this.selectedList.length) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      console.log("formData -> ", this.formData);
      try {
        let id = await this.$api.saveContract(this.formData)
        if (id) {
          this.$notify.success('保存成功！')
          this.initData()
          this.init()
        }
      } catch(err) {
        console.log('err is ->', err)
      }
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.cover = 0
      this.uploadFileList = fileList
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment = 0
      this.attachmentUploadFileList = fileList
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    }
  },
  async mounted() {
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .table-right
    float right
  .submitBtn
    float right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .content-left
  min-height 640px
  border-right 1px solid  #e8e8e8
  .el-cascader
    display block
    width 320px
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
  .iconBtns
    font-size: 20px
    color: rgba(0, 183, 158, 1)

</style>
